<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>

      <div class="detail-content-body-div flex-1">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="订单信息" name="order">
            <div class="order-header">
              <div class="section-title">
                订单编号:
                <span class="order-no">{{ form.activityOrderNo || "暂无" }}</span>
              </div>
            </div>
            <el-divider />
            <div class="section-title">订单基本信息</div>
            <el-form :model="form" label-width="150px" class="form-block" size="small">
              <el-row :gutter="20">
                <el-col v-for="item in formFields" :key="item.prop" :span="item.span || 12">
                  <el-form-item :label="item.label">
                    <el-input v-if="!item.type && item.options === undefined"
                      :value="item.prop === 'orderStatus' ? getOrderStatusName(form[item.prop]) : form[item.prop]"
                      @input="val => item.prop !== 'orderStatus' && (form[item.prop] = val)"
                      :disabled="!isEditable(item.prop)" :placeholder="item.placeholder || ''" />
                    <el-select v-else-if="item.options" v-model="form[item.prop]" :disabled="!isEditable(item.prop)"
                      :placeholder="item.placeholder || '请选择'" class="full-width">
                      <el-option v-for="option in item.options" :key="option.value" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                    <el-date-picker v-else-if="item.type === 'datetime'" v-model="form[item.prop]" type="datetime"
                      :disabled="!isEditable(item.prop)" :placeholder="item.placeholder || '请选择日期时间'"
                      value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" size="small">
                    </el-date-picker>
                    <el-input v-else-if="item.type === 'textarea'" type="textarea" :rows="item.rows || 3"
                      v-model="form[item.prop]" :disabled="!isEditable(item.prop)" :placeholder="item.placeholder || ''"
                      :maxlength="item.prop === 'remark' ? 500 : undefined" :show-word-limit="item.prop === 'remark'" />
                    <ZD-area-select v-else-if="item.type === 'area-select'" ref="areaSelect" :key="areaSelectKey"
                      :showLevel="'3'" :selProvince="form.province" :selCity="form.city" :selArea="form.area"
                      :disabledFlag="!isEditable('province')" @updateSelAreas="updateAreaSelection" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>

          <el-tab-pane label="月费服务信息" name="flow">
            <FlowServiceTable :activity-order-id="form.activityOrderId" :activity-order-no="form.activityOrderNo" />
          </el-tab-pane>

          <el-tab-pane label="解约申请记录" name="terminate">
            <TerminateRecordTable :activityorderNo="form.activityOrderNo" />
          </el-tab-pane>
        </el-tabs>

        <div class="bottom-actions">
          <el-button type="primary" @click="onSave" v-if="activeTab === 'order'">保存</el-button>
          <el-button @click="onBack">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FlowServiceTable from "./flow-service-table.vue";
import TerminateRecordTable from "./terminate-record-table.vue";
import ZDAreaSelect from "@/components/area-select/index.vue";

export default {
  name: "AnxinPackDetail",
  components: {
    FlowServiceTable,
    TerminateRecordTable,
    ZDAreaSelect,
  },
  data() {
    return {
      mode: this.$route.query.mode || "view",
      activeTab: "order",
      areaSelectKey: 0,
      editableFields: [
        "activityOrderContractStatusName",
        "pileInstallOrderNo",
        "activityOrderInstallStatusName",
        "pileInstallCompletedTime",
        "province",
        "city",
        "area",
        "address",
        "remark",
      ],
      formFields: [
        { label: "用户姓名", prop: "name", placeholder: "请输入用户姓名" },
        { label: "用户手机号", prop: "mobile", placeholder: "请输入用户手机号" },
        { label: "购买名称", prop: "purchaseName", placeholder: "请输入购买名称" },
        { label: "报名创建时间", prop: "createdWhen", type: "datetime" },
        { label: "订单状态", prop: "orderStatus", placeholder: "请选择订单状态" },
        { label: "流量服务状态", prop: "actualAmountStatus", placeholder: "请选择流量服务状态" },
        {
          label: "客服联系状态",
          prop: "activityOrderContractStatusName",
          options: [
            { label: "待联系", value: "待联系" },
            { label: "已联系", value: "已联系" },
            { label: "未联系上", value: "未联系上" },
          ],
        },
        { label: "关联主服订单编号", prop: "pileInstallOrderNo", placeholder: "请输入关联主服订单号" },
        {
          label: "安装状态",
          prop: "activityOrderInstallStatusName",
          options: [
            { label: "未勘察未安装", value: "未勘察未安装" },
            { label: "已勘察已安装", value: "已勘察已安装" },
            { label: "已勘察不安装", value: "已勘察不安装" },
            { label: "未勘察不安装", value: "未勘察不安装" },
          ],
        },
        { label: "充电桩安装完成时间", prop: "pileInstallCompletedTime", type: "datetime" },
        { label: "产品编号", prop: "pileCode", placeholder: "" },
        { label: "充电桩资产编号", prop: "pileAssetCode", placeholder: "请输入充电桩资产编号" },
        { label: "充电桩绑定激活时间", prop: "bindTime", type: "datetime" },
        { label: "充电桩使用状态", prop: "activateStatusName", placeholder: "请选择充电桩使用状态" },
        {
          label: "商家代扣状态",
          prop: "holdAgreement",
          options: [
            { label: "是", value: "Y" },
            { label: "否", value: "N" },
          ],
        },
        { label: "当前流量服务开始时间", prop: "actualAmountStartTime", type: "datetime" },
        { label: "当前流量服务到期时间", prop: "actualAmountEndTime", type: "datetime" },
        { label: "解约申请时间", prop: "cancelRequestTime", type: "datetime" },
        { label: "解约完成时间", prop: "cancelFinishTime", type: "datetime" },
        { label: "解约应退金额（元）", prop: "cancelAmount", placeholder: "请输入解约应退金额（元）" },
        { label: "解约应付金额（元）", prop: "cancelPayableAmount", placeholder: "请输入解约应付金额（元）" },
        { label: "解约原因", prop: "cancelReason", placeholder: "请输入解约原因" },
        { label: "是否买断回退", prop: "buyoutOrNot", placeholder: "请选择是否买断回退" },
        { label: "回退金额（元）", prop: "rebackedAmount", placeholder: "请输入回退金额（元）" },
        { label: "省市区", prop: "areaSelect", type: "area-select", span: 24 },
        { label: "详细地址", prop: "address", placeholder: "请输入详细地址" },
        { label: "备注", prop: "remark", type: "textarea", rows: 4, placeholder: "请输入备注信息（500字以内）", span: 24 },
      ],
      form: {
        orderNo: this.$route.query.orderNo || "",
        activityOrderNo: this.$route.query.orderNo || "",
        activityOrderId: "",
        name: "",
        mobile: "",
        purchaseName: "",
        createdWhen: "",
        orderStatus: "",
        actualAmountStatus: "",
        actualAmountStartTime: "",
        actualAmountEndTime: "",
        actualAmountDaysRemaining: "",
        actualAmountCumulativeMonths: "",
        actualAmountTotal: "",
        holdAgreement: "",
        activityOrderContractStatusName: "",
        activityOrderInstallStatusName: "",
        remark: "",
        pileInstallOrderNo: "",
        pileInstallCompletedTime: "",
        pileCode: "",
        pileAssetCode: "",
        activateStatusName: "",
        bindTime: "",
        activateOperatePer: "",
        activateOperateWhen: "",
        cancelRequestTime: "",
        cancelFinishTime: "",
        cancelReason: "",
        cancelPayableAmount: "",
        cancelAmount: "",
        buyoutOrNot: "",
        rebackedAmount: "",
        rebackedAmountOperatePer: "",
        refundOperateTime: "",
        refundFinishTime: "",
        province: "",
        city: "",
        area: "",
        address: "",
        filePath: "",
      },

      pageTitle: "安心包商品订单详情",
      detailBreadCrumb: [
        { type: "title", name: "首页" },
        { type: "title", name: "营销活动" },
        { type: "title", name: "安心包商品订单列表" },
        { type: "title", name: "订单详情" },
      ],
    };
  },
  watch: {
    "$route.query"(val) {
      this.mode = val.mode || "view";
      this.form.orderNo = val.orderNo || "";
      this.form.activityOrderNo = val.orderNo || "";
      this.updatePageInfo(val);
      if (val.orderNo) {
        this.loadDetailData();
      }
    },
  },
  mounted() {
    this.updatePageInfo(this.$route.query);
    this.loadDetailData();
  },
  methods: {
    getOrderStatusName(status) {
      const statusMap = {
        TO_ACTIVATION: "待激活",
        IN_USE: "使用中",
        PAUSE: "暂停使用",
        IN_CANCELLED_BUYOUT: "已解约(买断)",
        IN_CANCELLED_REFUNDED: "已解约(退出)",
      };
      return statusMap[status] || status;
    },
    updatePageInfo(query) {
      // 这里保留原逻辑结构，只改标题与面包屑为安心包
      if (query.mode === "edit") {
        this.pageTitle = "安心包598商品订单详情";
        this.detailBreadCrumb = [
          { type: "title", name: "首页" },
          { type: "title", name: "营销活动" },
          { type: "title", name: "安心包598活动" },
          { type: "title", name: "安心包598商品订单" },
          { type: "title", name: "订单详情" },
        ];
      } else {
        this.pageTitle = "安心包598商品订单详情";
        this.detailBreadCrumb = [
          { type: "title", name: "首页" },
          { type: "title", name: "营销活动" },
          { type: "title", name: "安心包598活动" },
          { type: "title", name: "安心包598商品订单" },
          { type: "title", name: "订单详情" },
        ];
      }
    },
    loadDetailData() {
      if (!this.form.activityOrderNo) {
        this.$message.error("缺少订单编号参数");
        return;
      }

      this.$U.showLoading(this);
      const params = {
        activityOrderNo: this.form.activityOrderNo,
      };

      this.$H
        .post(this, this.$A.activityOrder.get, params)
        .then((res) => {
          if (res.data && res.data.status === 200) {
            const data = res.data.data || {};
            Object.keys(data).forEach((key) => {
              if (this.form.hasOwnProperty(key)) {
                this.form[key] = data[key];
              }
            });
            Object.keys(this.form).forEach((key) => {
              if (data.hasOwnProperty(key) && data[key] !== null && data[key] !== undefined) {
                this.form[key] = data[key];
              }
            });
            this.normalizeDetailData(data);
            this.$nextTick(() => {
              this.areaSelectKey += 1;
            });
          } else {
            this.$message.error(res.data?.message || "获取详情失败");
          }
        })
        .catch((err) => {
          console.error("获取详情失败:", err);
          this.$message.error("获取详情失败");
        })
        .finally(() => {
          this.$U.hideLoading(this);
        });
    },
    isEditable(key) {
      return this.editableFields.includes(key);
    },
    onSave() {
      // 校验：填写了安装完成时间，必须先填写关联主服订单编号
      if (this.form.pileInstallCompletedTime && !this.form.pileInstallOrderNo) {
        this.$message.error("填写充电桩安装完成时间时，必须先填写关联主服订单编号");
        return;
      }
      // 校验：选择已勘察已安装，必须填写安装完成时间
      if (
        this.getInstallStatusCode(this.form.activityOrderInstallStatusName) === "INVESTIGATION_INSTALL_COMPLETED" &&
        !this.form.pileInstallCompletedTime
      ) {
        this.$message.error("选择安装状态为已勘察已安装时，必须填写安装完成时间");
        return;
      }

      const updateParams = {
        activityOrderNo: this.form.activityOrderNo,
        activityOrderContractStatus: this.getContractStatusCode(this.form.activityOrderContractStatusName),
        activityOrderContractStatusName: this.form.activityOrderContractStatusName,
        activityOrderInstallStatus: this.getInstallStatusCode(this.form.activityOrderInstallStatusName),
        activityOrderInstallStatusName: this.form.activityOrderInstallStatusName,
        pileInstallOrderNo: this.form.pileInstallOrderNo,
        // 兼容部分活动接口字段名
        mainServiceOrderNo: this.form.pileInstallOrderNo,
        pileInstallCompletedTime: this.form.pileInstallCompletedTime,
        // 兼容部分活动接口字段名
        pileInstallCompleteTime: this.form.pileInstallCompletedTime,
        activityOrder: {
          province: this.form.province,
          city: this.form.city,
          area: this.form.area,
          address: this.form.address,
          remark: this.form.remark || "",
        },
      };

      this.$U.showLoading(this);

      this.$H
        .post(this, this.$A.activityOrder.update, updateParams)
        .then((res) => {
          if (res.data && res.data.status === 200) {
            this.$message.success("保存成功!");
            this.updateLocalFormData(updateParams);
          } else {
            this.$message.error(res.data?.message || "保存失败");
          }
        })
        .catch((err) => {
          console.error("保存失败:", err);
          this.$message.error("保存失败");
        })
        .finally(() => {
          this.$U.hideLoading(this);
        });
    },
    getContractStatusCode(statusName) {
      const statusMap = {
        待联系: "WAIT_CONTRACT",
        已联系: "CONTRACTED",
        未联系上: "NOT_CONTRACT",
      };
      return statusMap[statusName] || statusName;
    },
    getInstallStatusCode(statusName) {
      const statusMap = {
        未勘察未安装: "INVESTIGATION_INSTALL_INIT",
        已勘察已安装: "INVESTIGATION_INSTALL_COMPLETED",
        已勘察不安装: "INVESTIGATION_FINISHED_NOT_INSTALL",
        未勘察不安装: "INVESTIGATION_INIT_NOT_INSTALL",
      };
      return statusMap[statusName] || statusName;
    },
    normalizeDetailData(data) {
      if (!data) return;
      const isEmpty = (v) => v === "" || v === null || v === undefined;
      if (isEmpty(this.form.pileInstallOrderNo)) {
        this.form.pileInstallOrderNo = data.pileInstallOrderNo || data.mainServiceOrderNo || "";
      }
      if (isEmpty(this.form.pileInstallCompletedTime)) {
        this.form.pileInstallCompletedTime = data.pileInstallCompletedTime || data.pileInstallCompleteTime || "";
      }
    },
    updateLocalFormData(updatedData) {
      Object.keys(updatedData).forEach((key) => {
        if (key !== "activityOrder" && this.form.hasOwnProperty(key)) {
          this.form[key] = updatedData[key];
        }
      });
      if (updatedData.activityOrder) {
        Object.keys(updatedData.activityOrder).forEach((key) => {
          if (this.form.hasOwnProperty(key)) {
            this.form[key] = updatedData.activityOrder[key];
          }
        });
      }
    },
    updateAreaSelection(areaData) {
      this.form.province = areaData.province || "";
      this.form.city = areaData.city || "";
      this.form.area = areaData.area || "";
    },
    onBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.detail-container {
  padding: 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.order-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.order-no {
  color: #409eff;
  font-weight: 500;
}

.bottom-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

::v-deep .el-form-item__label {
  white-space: nowrap;
}
</style>
